import store from '../store'
import { createAuthInstance } from '../api/general'

const identityHost = process.env.VUE_APP_IDENTITY_API_HOST

const createResource = async ({ path, displayName, description, tag }) => {
  const serviceName = 'labeling'
  const creatorId = store.getters.userId
  const res = await createAuthInstance(identityHost).post('resource', {
    serviceName,
    creatorId,
    path,
    displayName,
    description,
    tag
  })
  return res
}

const checkPermission = async (resourcePath) => {
  const serviceName = 'labeling'
  const userInfo = store.getters.userInfo
  const tenantId = userInfo.tenantId
  const accountId = store.getters.userId

  const res = await createAuthInstance(identityHost).post('acl/type', {
    tenantId,
    serviceName,
    accountId,
    resourcePath
  })
  if (res.status === 200 && res.hasOwnProperty('data')) {
    console.info(res.data)
    return res.data.directResourceAccess || res.data.indirectResourceAccess
  }
  return false
}

const getAccountResourceAcl = async () => {
  const serviceName = 'labeling'
  const userInfo = store.getters.userInfo
  const tenantId = userInfo.tenantId
  const accountId = store.getters.userId
  const type = 'all'

  const res = await createAuthInstance(identityHost).get(`acl/account/${accountId}`, {
    params: {
      tenantId,
      serviceName,
      type
    }
  })
  if (res.status === 200) {
    console.info(res.data)
    return res.data
  }
  return {}
}

const removeAcl = async (options) => {
  await createAuthInstance(identityHost).post('resource/remove/subtree', options)
}

export const aclService = {
  createResource,
  checkPermission,
  getAccountResourceAcl,
  removeAcl
}
